export const generalQuery = [
    {
      id: 1,
      question: "What is your luggage return policy?",
      answer: "You can return any item within 30 days of travel and Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit optio, nisi tenetur cupiditate doloribus quisquam.",
    },
    {
      id: 2,
      question: "Do you offer Luggage shipping?",
      answer: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Unde sapiente quam temporibus odit, fuga magnam nesciunt autem tempore, porro nemo repellat voluptates, expedita tempora voluptas!",
    },
    {
      id: 3,
      question: "How can I track my Flight Status?",
      answer: "You can track your flight using the PNR in shankh air website and Lorem ipsum dolor sit amet consectetur adipisicing elit. Unde sapiente quam temporibus odit, fuga magnam nesciunt autem tempore, porro nemo repellat voluptates, expedita tempora voluptas!",
    },
    {
      id: 4,
      question: "What type payment methods do you accept?",
      answer: "We accept all major credit cards, PayPal, and Apple Pay. Lorem ipsum dolor sit amet consectetur adipisicing elit. Unde sapiente quam temporibus odit, fuga magnam nesciunt autem tempore, porro nemo repellat voluptates, expedita tempora voluptas!",
    },
    {
      id: 5,
      question: "How can I contact customer support?",
      answer: "You can reach our customer support team via email or phone. Lorem ipsum dolor sit amet consectetur adipisicing elit. Unde sapiente quam temporibus odit, fuga magnam nesciunt autem tempore, porro nemo repellat voluptates, expedita tempora voluptas!",
    }
];

export const bookingQuery = [
    {
      id: 1,
      question: "How can I book a flight?",
      answer: "You can book a flight through our website or mobile app by selecting your destination, dates, and preferred flight options.",
    },
    {
      id: 2,
      question: "Can I book a flight for someone else?",
      answer: "Yes, you can book a flight for someone else by entering their details during the booking process.",
    },
    {
      id: 3,
      question: "What documents are required for booking a flight?",
      answer: "You will need a valid government-issued ID and payment details to complete your booking.",
    },
    {
      id: 4,
      question: "Can I reserve a seat during booking?",
      answer: "Yes, you can select your preferred seat during the booking process, subject to availability.",
    },
];

export const refundCancelledQuery = [
    {
      id: 1,
      question: "What is your refund policy for canceled flights?",
      answer: "If your flight is canceled, you are eligible for a full refund or rebooking on an alternative flight.",
    },
    {
      id: 2,
      question: "How long does it take to process a refund?",
      answer: "Refunds are typically processed within 7-10 business days, depending on your payment method.",
    },
    {
      id: 3,
      question: "Can I get a refund for a non-refundable ticket?",
      answer: "Non-refundable tickets are not eligible for refunds unless the airline cancels the flight.",
    },
    {
      id: 4,
      question: "How do I request a refund for a canceled flight?",
      answer: "You can request a refund through our website or by contacting our customer support team.",
    },
];

export const luggagePackingQuery = [
    {
      id: 1,
      question: "What is the baggage allowance for my flight?",
      answer: "The baggage allowance varies by ticket type and destination. Please check your booking confirmation for details.",
    },
    {
      id: 2,
      question: "Are there any items prohibited in checked luggage?",
      answer: "Yes, items such as flammable materials, explosives, and hazardous chemicals are prohibited in checked luggage.",
    },
    {
      id: 3,
      question: "Can I carry liquids in my hand luggage?",
      answer: "Liquids in hand luggage must be in containers of 100ml or less and placed in a clear, resealable plastic bag.",
    },
    {
      id: 4,
      question: "What should I do if my luggage is lost or damaged?",
      answer: "If your luggage is lost or damaged, please report it to the airline's baggage service desk immediately upon arrival.",
    },
];